import { gql } from 'graphql-tag'
import fragmentEventLocation from '../event-location/fragment-event-location'
import fragmentEventAgendaSection from '../event-agenda-section/fragment-event-agenda-section'
import fragmentModuleMedia from '#layers/core/data-layer/modules/module-media/fragment-module-media'

export default gql`
  ${fragmentEventLocation}
  ${fragmentEventAgendaSection}
  ${fragmentModuleMedia}
  fragment EventLogisticsFragment on EventLogistics {
    sys {
      id
    }
    contentType: __typename
    title
    description {
      json
    }
    image {
      ...ModuleMediaFragment
    }
    map {
      lat
      lon
    }
    eventAgendaOrLocationSection {
      ... on EventAgendaSection {
        ...EventAgendaSectionFragment
      }
      ... on EventLocation {
        ...EventLocationFragment
      }
    }
  }
`
